import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { projectContext, loadingContext, urlValue, unfolder, openModalVw, closeModalVw, openAlert, useTranslate } from '../lib';
import DataTable from './provider/datatable/Datatable';
import ModalVw, { ModalBody, ModalContent, ModalHeader } from './common/ModalVw';
import { Alerts } from './common/Alerts';
import { useForm } from 'react-hook-form';
import { SelectNesting } from './common/Inputs/Select'

const ProjectAdministrators = ({refresh}) => {
  const [selectedProject] = useContext(projectContext);
  const [loading, setLoading] = useContext(loadingContext);
  const [administrators, setAdministrators] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [roleUser, setRoleUser] = useState(1)
  const [role, setRole] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    edit: false
  });
  const [alert, setAlert] = useState({ title: '', visible: false });
  const { t } = useTranslate();  
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (selectedProject?.id) {
      fetchAdministrators();
    }
  }, [refresh]);

  useEffect(() => {
    if (selectedProject?.id) {
      fetchAdministrators();
    }
  }, [selectedProject]);

  const fetchAdministrators = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    
    setLoading(true);
    axios({
      method: 'get',
      url: `${urlValue}/studio/user/project-users-studio/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setAdministrators(response.data.admins || []);
        setLoading(false);
      })
      .catch(function (error) {
        console.error("Error fetching administrators:", error);
        setLoading(false);
      });
  };

  const openModal = (modal, admin) => {
    setSelectedAdmin(admin);
    
    if (modal === 'edit') {
      console.log(admin)
      openModalVw("#editadmin-md", () => setIsModalOpen({ ...isModalOpen, edit: true }));
      setValue('id', admin.id);
      setValue('ccms_id_studio', admin.ccms_id || '');
      setValue('ccms_name_studio', admin.ccms_name || '');
      setValue('name', admin.name || '');
      setValue('last_name', admin.last_name || '');
      setValue('email', admin.email || '');
      setValue('role_user_studio_edit', admin.role || 1);
      setRoleUser(admin.role || 1)
    } else if (modal === 'delete') {
      openModalVw("#deleteadmin-md", () => setIsModalOpen({ ...isModalOpen, delete: true }));
    }
  };

  const onSubmitDelete = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let userId = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    
    setLoading(true);
    axios({
      method: 'post',
      url: `${urlValue}/studio/user/user-project/access/delete`,
      headers: {
        user: userId,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        id: selectedAdmin.id,
        project: selectedProject.id
      }
    })
      .then(function (response) {
        openAlert('#alert-admin', () => { 
          setAlert({ title: t('alerts.administratorRemoved'), visible: true }) 
        }, 4000, () => { 
          setAlert({ ...alert, visible: false }) 
        });
        
        setLoading(false);
        closeModalVw("#deleteadmin-md", () => setIsModalOpen({ ...isModalOpen, delete: false }));
        fetchAdministrators();
      })
      .catch(function (error) {
        console.error("Error removing administrator:", error);
        openAlert('#alert-admin', () => { 
          setAlert({ title: t('alerts.errorRemovingAdministrator'), visible: true, error: true }) 
        }, 4000, () => { 
          setAlert({ ...alert, visible: false }) 
        });
        
        setLoading(false);
        closeModalVw("#deleteadmin-md", () => setIsModalOpen({ ...isModalOpen, delete: false }));
      });
  };

  const onSubmitEdit = (data) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let userId = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    
    setLoading(true);
    axios({
      method: 'post',
      url: `${urlValue}/studio/user/admin-info/update`,
      headers: {
        user: userId,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        id: data.id,
        ccms_id: data.ccms_id_studio,
        ccms_name: data.ccms_name_studio,
        name: data.name,
        last_name: data.last_name,
        email: selectedAdmin.email,
        role: roleUser,
      }
    })
      .then(function (response) {
        openAlert('#alert-admin', () => { 
          setAlert({ title: t('alerts.administratorUpdated'), visible: true }) 
        }, 4000, () => { 
          setAlert({ ...alert, visible: false }) 
        });
        
        setLoading(false);
        closeModalVw("#editadmin-md", () => setIsModalOpen({ ...isModalOpen, edit: false }));
        fetchAdministrators();
      })
      .catch(function (error) {
        console.error("Error updating administrator:", error);
        openAlert('#alert-admin', () => { 
          setAlert({ title: t('alerts.administratorNotUpdated'), visible: true, error: true }) 
        }, 4000, () => { 
          setAlert({ ...alert, visible: false }) 
        });
        
        setLoading(false);
        closeModalVw("#editadmin-md", () => setIsModalOpen({ ...isModalOpen, edit: false }));
      });
  };

  const filteredAdmins = administrators.filter(admin => {
    if (search === '') {
      return true;
    } else {
      return (
        admin.name?.toLowerCase().includes(search.toLowerCase()) ||
        admin.email?.toLowerCase().includes(search.toLowerCase()) ||
        admin.ccms_name?.toLowerCase().includes(search.toLowerCase()) ||
        admin.ccms_id?.toString().toLowerCase().includes(search.toLowerCase())
      );
    }
  });

  const columns = [
    {
      header: t('common.ntUser'),
      field: 'ntuser',
      width: '50%',
      render: (value, admin) => {
        if (!admin) return <div style={{ fontSize: 12 }}>-</div>;
        return (
          <div style={{ fontSize: 12 }}>
            {admin.ccms_name}
          </div>
        );
      }
    },
    {
      header: t('common.bms'),
      field: 'bms',
      width: '50%',
      align: 'left',
      render: (value, admin) => <div style={{ fontSize: 12 }}>{admin.ccms_id}</div>
    },
    {
      header: t('common.actions'),
      field: 'actions',
      width: '20%',
      align: 'center',
      render: (_, admin) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <img
            src="/icons/edit.png"
            alt="edit"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openModal('edit', admin)}
          />
          <img
            src="/icons/trash.png"
            alt="trash"
            style={{ width: 15, cursor: 'pointer' }}
            onClick={() => openModal('delete', admin)}
          />
        </div>
      )
    }
  ];

  return (
    <>
      <div className="body pt-1 pb-3 account-container account-c w-100 mt-5" style={{ backgroundColor: '#F9F9F9', borderRadius: 25, marginTop: 30 }}>
        <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18, marginBottom: 15 }}>{t('menu.projectAdministrators')} - Studio</h2>
        
        {/* Search toolbar */}
        <div className="pl-3 d-flex flex-row align-items-center justify-space-between">
          <div className="head w-100">
            <div className="home-search bg-white d-flex flex-row align-items-center justify-space-between"
              style={{ borderRadius: 20, backgroundColor: 'white', width: 215, border: '1px solid gray' }}>
              <input
                type="text"
                placeholder={t('common.search')}
                onChange={event => setSearch(event.target.value)}
                style={{ border: 'none', marginLeft: 7, maxWidth: 160, borderRadius: '20px' }}
                className="p-2 home-search"
              />
              <div className="p-1 pr-4 mt-1">
                <img src="/icons/search.svg" style={{ width: 16 }} alt="magnifying" />
              </div>
            </div>
          </div>
        </div>
        
        <div className="pl-2">
          <DataTable
            columns={columns}
            data={filteredAdmins.filter(admin => admin && admin.id).map(admin => admin)}
            tableId="admins-table"
            keyField="id"
            emptyMessage={t('menu.noAdministrators')}
            tableStyles={{ 
              borderRadius: '8px',
              overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
            headerStyles={{
              backgroundColor: '#f5f5f5',
              fontWeight: 'bold',
              fontSize: '14px'
            }}
            rowStyles={{
              transition: 'background-color 0.2s'
            }}
            cellStyles={{
              padding: '8px 15px'
            }}
          />
        </div>
      </div>

      {/* Delete Modal */}
      {isModalOpen.delete && (
        <ModalVw id="deleteadmin-md" visible={isModalOpen.delete}>
          <ModalContent clases="sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3 w-[27%] bg-white">
            <ModalHeader title="" onClose={() => closeModalVw("#deleteadmin-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))} />
            <ModalBody clases="">
              <div id="container-modal" className="modal-c">
                <img src="/icons/alert.png" alt="" />
                <h1>{t('menu.deleteAdministrator')}</h1>
                <h1>{t('menu.deleteConfirmQuestion')}</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deleteadmin-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    {t('common.cancel')}
                  </button>
                  <button onClick={onSubmitDelete} className="accept">
                    {t('common.yes')}
                  </button>
                </div>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>
      )}

      {/* Edit Modal */}
      {isModalOpen.edit && (
        <ModalVw id="editadmin-md" visible={isModalOpen.edit}>
          <ModalContent clases="sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3 w-[27%] bg-white">
            <ModalHeader title="" onClose={() => closeModalVw("#editadmin-md", () => setIsModalOpen({ ...isModalOpen, edit: false }))} />
            <ModalBody clases="">
              <div id="container-modal" className="addUser-modal">
                <h2>{t('menu.deleteAdministrator')}</h2>
                <form onSubmit={handleSubmit(onSubmitEdit)}>
                  <div className="inputs-modal">
                    <input type="hidden" {...register('id')} />
                    <div className="input">
                      <span>{t('common.bms')}:</span>
                      <input
                        id="ccms_id_studio" placeholder={t('menu.specificUserId')}
                        {...register('ccms_id_studio', { required: true, pattern: /^\d+$/ })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>{t('common.ntUser')}:</span>
                      <input id="ccms_name_studio" placeholder={t('menu.enterCCMS')} 
                        {...register('ccms_name_studio', { required: true })} type="text" />
                    </div>
                    <div className="input">
                      <span>{t('menu.firstName')}:</span>
                      <input
                        placeholder={t('menu.administratorFirstName')}
                        {...register('name', { required: true })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>{t('menu.lastName')}:</span>
                      <input 
                        placeholder={t('menu.administratorLastName')}
                        {...register('last_name', { required: true })} 
                        type="text" 
                      />
                    </div>
                    <SelectNesting
                      id="role_user_studio_edit"
                      boxInfo={false} tooltipText= {t('menu.enterRole')} 
                      title={`${t('menu.genai.selectRole')}`}
                      {...register('role_user_studio_edit', { required: true })}
                      onChange={(e) => {
                        setRoleUser(e.target.value)
                      }}
                    >
                      <option key='roleedit0' value='1'>{t('common.admin')}</option>
                      <option key='roleedit1' value='4'>{t('common.reader')}</option>
                      {(role == 6 || role == 5) && <option key='roleedit1' value="5">{t('common.trainer')}</option>}
                      {role == 6 && <option key='roleedit2' value='6'>{t('common.superAdmin')}</option>}
                    </SelectNesting>
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#editadmin-md", () => setIsModalOpen({ ...isModalOpen, edit: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      {t('common.cancel')}
                    </button>
                    <button className="accept btn-bottom btn-bottom-create" type="submit">
                      {t('common.confirm')}
                    </button>
                  </div>
                </form>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>
      )}

      {alert.visible && <Alerts id="alert-admin" title={alert.title} error={alert.error} />}
    </>
  );
};

export default ProjectAdministrators;